import React from 'react';
import { Tooltip } from 'antd';
import { QuestionCircleFilled } from "@ant-design/icons";

interface ForceApprovalAnnotationsProps {
  isStatusForceApproved: boolean
  isMobile?: boolean
}

export const ForceApprovalAnnotations = (props: ForceApprovalAnnotationsProps) => {

  if (!props.isStatusForceApproved) {
    return <></>
  }

  let promptTextList: Array<any> = [];
  promptTextList.push(<div>「外部承認」について</div>);
  promptTextList.push(<div>本勤怠情報は、スキルマップサイト外で承認済です。そのため、スキルマップサイト上での手当金算出対象には入りません。</div>);

  let trigger = props.isMobile ? "click" : undefined; // スマホ画面はクリックで開く

  return <Tooltip
    placement="topLeft"
    trigger={trigger}
    title={promptTextList}
    overlayStyle={{ maxWidth: '1000px' }}>
    <span>&nbsp;
      <QuestionCircleFilled />&nbsp;
    </span>
  </Tooltip>

}